import api from './api';

export const getProductImages = async (params) => {
  const response = await api.get('/auth/product-image', { params });
  return response.data;
};

export const getProductImage = async (id) => {
  const response = await api.get(`/auth/product-image/${id}`);
  return response.data;
};

export const createProductImage = async (data) => {
  const response = await api.post('/auth/product-image', data);
  return response.data;
};

export const updateProductImage = async (data) => {
  const response = await api.put('/auth/product-image', data);
  return response.data;
};

export const deleteProductImage = async (id) => {
  const response = await api.delete(`/auth/product-image/${id}`);
  return response.data;
};
